/** Falling green leaves + brown twig glyphs for release events only —
 *  never colorful party confetti (HANDOFF §6.7). Deterministic by index. */
export function ConfettiLeaves() {
  const items = Array.from({ length: 22 }, (_, i) => i);
  return (
    <div class="confetti" aria-hidden="true">
      {items.map((i) => {
        const left = (i * 37) % 100;
        const delay = (i * 53) % 600;
        const size = 12 + ((i * 29) % 10);
        const leaf = i % 4 !== 0;
        return (
          <span key={i} style={{ left: `${left}%`, animationDelay: `${delay}ms` }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round">
              {leaf ? (
                <path d="M5 19C5 9 13 4 20 4c0 7-3 15-13 15zM5 19c2-5 5-8 9-10" />
              ) : (
                <path d="M4 20L20 4M12 12l4 1M9 15l-1 4" />
              )}
            </svg>
          </span>
        );
      })}
    </div>
  );
}
